import {
  Box,
  DropdownOptions,
  FormProvider,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  TooltipPopup,
} from 'dash-ui';

import SaveSaleTeamUserModal from 'pages/external-sales/components/SaveSalesTeamUserModal/SaveSaleTeamUserModal';
import SendRegistrationLinkToUserModal from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/components/SendRegistrationLinkToUserModal/SendRegistrationLinkToUserModal';

import ExternalSalesPageHeader from './components/ExternalSalesPageHeader/ExternalSalesPageHeader';
import ExternalSalesPageTable from './components/ExternalSalesPageTable/ExternalSalesPageTable';
import SaveExternalSaleModal from './components/SaveExternalSaleModal/SaveExternalSaleModal';
import { FormFieldsList } from 'pages/external-sales/components/SaveSalesTeamUserModal/SaveSaleTeamUserModal.constants';
import { SaveSaleFormFieldsList } from './constants';

const SaveExternalSale = () => (
  <FormProvider fieldsList={SaveSaleFormFieldsList}>
    <SaveExternalSaleModal />
  </FormProvider>
);

const SaveSaleTeamUser = () => (
  <FormProvider fieldsList={FormFieldsList}>
    <SaveSaleTeamUserModal />
  </FormProvider>
);

const ExternalSaleTeamsPage = () => (
  <PaginationProvider>
    <SortProvider>
      <SearchProvider>
        <ModalProvider>
          <Box w="100%">
            <DropdownOptions />
            <TooltipPopup />
            <ExternalSalesPageHeader />
            <ExternalSalesPageTable />
            <SaveExternalSale />
            <SaveSaleTeamUser />
            <SendRegistrationLinkToUserModal />
          </Box>
        </ModalProvider>
      </SearchProvider>
    </SortProvider>
  </PaginationProvider>
);

export default ExternalSaleTeamsPage;
